import React from 'react';

import { observer } from 'mobx-react';

import ChatWindowHeader from '../chat-window-header/chat-window-header';
import ChatWindowBody from '../chat-window-body/chat-window-body';
import ChatWindowInput from '../chat-window-input/chat-window-input';
import { useChatStore } from '../stores/use-chat-store';

const ChatWindow = observer(() => {
	const { chatStore } = useChatStore();
	const currentChat = chatStore?.getCurrentChat;

	return currentChat ? (
		<div className="chat-window">
			<ChatWindowHeader />
			<ChatWindowBody />
			<ChatWindowInput />
		</div>
	) : null;
});

export default ChatWindow;
